// Copyright (C) 2012 Minted Inc.
// All Rights Reserved

/*
  UMD header generated via modularize.js at 2015-04-08T01:12:32.773Z
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_',
  'minted:constants': ['EnvelopeColorOptionNameToId', 'FreeWhiteEnvelopeColorIds'],
  'minted:view/product_details/constants': []
})(this, function (m_module, Backbone, $, _, constants_module) {

var M = m_module.M;
var EnvelopeColorOptionNameToId = constants_module.EnvelopeColorOptionNameToId;

M.View = M.View || {};
M.View.ProductDetails = M.View.ProductDetails || {};

/**
 * Renders a paper picker HTML radio select list
 */
M.View.ProductDetails.RadioEnvelopePicker = Backbone.View.extend({
  tagName: 'table',
  className: 'radioEnvelopePicker radioPicker',
  template: M.Template.ProductDetails.EnvelopeColorPicker,

  events: {
    'change': 'onChange'
  },

  initialize: function() {
    var that = this;
    this.$el = $(this.el);
    this.model.get('selectedEnvelopeColorOptionId');
    this.model.bind('priceUpdated', function() {
      that.render();
    });
  },

  /**
   * Renders the HTML for the radio format picker input.
   */
  render: function() {
    var that = this;

    this.$el.empty();
    _.each(this.model.get("envelopeOptionList"), function (envelopeOption) {
      var envelopeColorOptionId =
        EnvelopeColorOptionNameToId[envelopeOption.color_name];

      var selected =
        that.model.get('selectedEnvelopeColorOptionId') == envelopeColorOptionId;

      var price = that.model.getEnvelopePriceForSelectedQuantity();
      if (FreeWhiteEnvelopeColorIds.includes(envelopeColorOptionId)) {
        price = 0;
      }

      // TODO refactor price into an object that knows how many decimal places
      // it should retain!!
      if (price % 1) {
        price = price.toFixed(2);
      }
      var envelopeColorElem = that.template({
        'name': M.View.ProductDetails.
          ENVELOPE_DISPLAY_NAMES[envelopeColorOptionId],
        'elemId': M.View.ProductDetails.ENVELOPE_DOM_IDS[envelopeColorOptionId],
        'caption': M.View.ProductDetails.ENVELOPE_CAPTIONS[envelopeColorOptionId],
        'envelopeColorOptionId': envelopeColorOptionId,
        'price': price,
        'selected': selected
      });
      that.$el.append(envelopeColorElem);
    });

    this.$el.find('.caption').jTruncate({
      length: 25, lessText: 'less'
    });

    // Bind to the 'more'/'less' link created by jTruncate.
    // Note: We are using the class of the link to find the element since
    // jTruncate does not return a reference to it. Binding to .caption does not
    // work because the link intercepts the click.
    this.$el.find('.truncate_more_link').click(function () {
      that.trigger('moreButtonClicked');
    });

    return this;
  },

  /**
   * Triggers a envelopeSelected event when the format is changed.
   */
  onChange: function(e) {
    var selectedEnvelopeColorOptionId = $(e.target).data("id");
    this.trigger('envelopeSelected', selectedEnvelopeColorOptionId);
  }
});

M.View.ProductDetails.DieCutPanel = Backbone.View.extend({
  tagName: 'table',
  className: 'dieCutPanel radioPicker',
  template: M.Template.ProductDetails.DieCutPanel,

  initialize: function() {
    this.$el = $(this.el);
  },

  render: function() {
    var price = this.model.getDieCutPrice();
    var name = this.model.getDieCutName();
    price = price.toFixed(0);

    var dieCutTempl = this.template({
      price: price,
      name: name
    });
    this.$el.append(dieCutTempl);
    return this;
  },
});

return {
  RadioEnvelopePicker: M.View.ProductDetails.RadioEnvelopePicker,
  DieCutPanel: M.View.ProductDetails.DieCutPanel
};

});
